import { useFormik } from 'formik';
import { initialValues } from './formData';
import { cleanObj } from '../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import {
    asyncGetLabelParams,
    asyncGetParams,
} from '../../../../../services/param.service';
import { AlertsFilter } from '../../../../../shared/types/legalProceedings/alerts';

export const useAlertsFilters = (onFilter?: (data: AlertsFilter) => void) => {
    const [typesDocument, setTypesDocument] = useState<ISelect[]>([]);
    const [typesReceivedThrough, setTypesReceivedThrough] = useState<ISelect[]>(
        []
    );
    const [typesReceptionChannel, setTypesReceptionChannel] = useState<
        ISelect[]
    >([]);
    const [typesTypePqr, setTypesTypePqr] = useState<ISelect[]>([]);
    const [typesSubtypeDp, setTypesSubtypeDp] = useState<ISelect[]>([]);
    const [typesTransaction, setTypesTransaction] = useState<ISelect[]>([]);

    const onSubmit = (data: AlertsFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_STATUS).then((params) =>
            setTypesDocument(params)
        );
        asyncGetLabelParams(ParamEnum.PQR_HALF).then((params) =>
            setTypesReceivedThrough(
                params.map(({ name }) => ({ id: name, name }))
            )
        );
        asyncGetParams(ParamEnum.PQR_RECEPTION_CHANNEL).then((params) =>
            setTypesReceptionChannel(params)
        );
        asyncGetParams(ParamEnum.PQR_TYPE).then((params) =>
            setTypesTypePqr(params)
        );
        asyncGetLabelParams(ParamEnum.PQR_SUBTYPE_DP).then((params) =>
            setTypesSubtypeDp(params.map(({ name }) => ({ id: name, name })))
        );
        asyncGetParams(ParamEnum.PQR_PROCEDURE).then((params) =>
            setTypesTransaction(params)
        );
    }, []);

    return {
        formik,
        typesDocument,
        typesReceivedThrough,
        typesReceptionChannel,
        typesTypePqr,
        typesSubtypeDp,
        typesTransaction,
    };
};
